var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.598 11.4924C16.1838 11.3062 15.7016 11.5007 15.5207 11.9266C14.388 14.5935 11.8286 16.3167 9.00013 16.3167C6.75802 16.3167 4.68522 15.2326 3.35777 13.4548L6.15209 14.0265C6.59532 14.1173 7.02595 13.8211 7.11414 13.3652C7.20229 12.9093 6.91446 12.4662 6.47128 12.3755L1.88932 11.4379C1.44614 11.3474 1.01546 11.6433 0.927259 12.0992L0.0158735 16.8129C-0.0722706 17.2689 0.215561 17.712 0.658736 17.8027C0.712626 17.8137 0.766298 17.819 0.819206 17.819C1.20156 17.819 1.54334 17.5418 1.62079 17.1413L2.11977 14.5606C3.75458 16.6998 6.27618 18.0001 9.00013 18.0001C12.479 18.0001 15.6271 15.8807 17.0202 12.6006C17.2011 12.1747 17.0121 11.6785 16.598 11.4924Z",
    fill: "#650675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.341 0.1969C16.8978 0.106334 16.4671 0.402328 16.3789 0.858244L15.8799 3.43926C14.245 1.30024 11.7235 0 8.99979 0C5.52099 0 2.3729 2.11943 0.979664 5.39939C0.79874 5.82534 0.987737 6.32155 1.40178 6.50767C1.50847 6.55559 1.61958 6.57832 1.729 6.57832C2.04432 6.57832 2.34481 6.38967 2.47915 6.07342C3.61193 3.40655 6.17144 1.68333 8.99985 1.68333C11.2416 1.68333 13.3143 2.7672 14.6418 4.5448L11.8476 3.97295C11.4043 3.88233 10.9737 4.17832 10.8855 4.63424C10.7973 5.09015 11.0851 5.53328 11.5283 5.62401L16.1103 6.56171C16.1633 6.57254 16.2168 6.57787 16.27 6.57787C16.4306 6.57787 16.589 6.52917 16.7245 6.43602C16.9049 6.31201 17.0301 6.11932 17.0724 5.90037L17.9838 1.18656C18.072 0.7307 17.7841 0.287578 17.341 0.1969Z",
    fill: "#650675"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.112123f24a26574f5a25cbc6d5d80b99.svg";
export { ForwardRef as ReactComponent };